import React from "react";

import { HeaderBreadcrumb } from "../../../common/ui/layout/header/header-breadcrumb/HeaderBreadcrumb";
import { PageHeader } from "../../../common/ui/layout/header/PageHeader";
import { adminRoutes } from "../../AdminRoutes";
import { ResolutionsListingProvider } from "../context/ResolutionsListingProvider";
import { ResolutionsListing } from "./ResolutionsListing";

export const ResolutionsListingPage: React.VFC = () => {
    return (
        <ResolutionsListingProvider>
            <PageHeader>
                <HeaderBreadcrumb routes={adminRoutes} />
            </PageHeader>
            <ResolutionsListing />
        </ResolutionsListingProvider>
    );
};
